import React, { Component } from 'react';
import './IconButton.css';

export default class IconButton extends Component<any, any> {
  constructor(props:any) {
    super(props);
    this.state = {}
  }

  renderLabel() {
    if (this.props.label) {
      return <div className='IconButton-Label'>{this.props.label}</div>;
    }
  }

  render() {
    return (
      <div className='IconButton' style={this.props.style} onClick={this.props.onClick}>
        {this.props.img}{this.renderLabel()}
      </div>
    );
  }
}
